import React from 'react';
import { Helmet } from 'react-helmet';
import './apiPages.css';

import Footer from '../Footer';
import HeroComponentv2 from '../productComponent/hero/HeroComponentv2';
import ThreePanelCards from '../productComponent/benefits/ThreePanelCards';
import CaseStudyComponent from '../productComponent/customer/CaseStudyComponent';

// Import the hero image and llama images
import api_hero from "../../assets/images/api/api-header-dark.jpg";
import Llama_Watching from "../../assets/images/unauth/llama-watching-small.png";
import Llama_Music from "../../assets/images/unauth/llama-music-clay.png";

import llama_surfing_thumbnail from '../../assets/images/thumbnail/llama-bump-thumbnail.jpg';

// Import the images for ThreePanelCards
import Pannel1 from "../../assets/images/api/api-panel-1.jpg";
import Pannel2 from "../../assets/images/api/api-panel-2.jpg";
import Pannel3 from "../../assets/images/api/api-panel-3.jpg";

const StartupAPI = () => {
  const heroData = {
    title: 'Video Intelligence For Startups',
    subtitle:
      'Find product-market-fit, or scale what works, with an API that turns raw video data into actionable insights—without expanding your team.',
    buttonText: 'Start building now',
    imgSrc: api_hero,
    buttonLink: 'https://docs.bumpups.com/docs/getting-started',
    llamaWatching: Llama_Watching,
    llamaReading: Llama_Music
  };

  const caseStudyData = {
    leftImage: llama_surfing_thumbnail,
    title: 'Empower Your Startup',
    subtitle:
      'Use our API to transform raw video content into actionable insights, enabling smarter decisions and rapid growth.',
    buttonText: 'Start building now',
    buttonLink: 'https://docs.bumpups.com/docs/getting-started',
    stats: [
      { metrics: '5+', description: 'API endpoints available' },
      { metrics: 'AI-Driven', description: 'Videos into actionable assets' },
      { metrics: 'bump-1.0', description: 'Model optimized for voice-centric videos' },
    ],
  };

  // Updated data to include buttonLink for ThreePanelCard
  const threePanelData = {
    header: "Scale Smarter with Video Insights",
    subtext: "Our API simplifies video intelligence, allowing you to seamlessly integrate deep video analysis into your product. Transform raw footage into strategic data that powers innovation.",
    buttonText: "Read API Documentation",
    buttonLink: "https://docs.bumpups.com/docs/getting-started",
    cards: [
      {
        image: Pannel3,
        header: "Scalable Solutions",
        subtext: "Designed to grow with your startup, our API scales effortlessly to meet your evolving needs."
      },
      {
        image: Pannel1,
        header: "Rapid Integration",
        subtext: "Easily connect with our API and integrate deep video insights into your workflow."
      },
      {
        image: Pannel2,
        header: "Actionable Data",
        subtext: "Turn raw video content into strategic information that drives growth."
      }
    ]
  };

  return (
    <div className="api-main-container">
      <Helmet>
        <title>Bumpups for startups | Bumpups.com</title>
        <meta
          name="description"
          content="Empower your startup with Bumpups' advanced video processing API. Unlock actionable insights from raw video data to streamline workflows, drive innovation, and scale your business without expanding your team."
        />
      </Helmet>
      <HeroComponentv2 data={heroData} />
      <ThreePanelCards data={threePanelData} />
      <CaseStudyComponent caseStudyData={caseStudyData} />
      <Footer />
    </div>
  );
};

export default StartupAPI;
